import React, { useState } from 'react';
import './Work.scss';
import s1 from '../assests/1.jpeg';
import s2 from '../assests/4.jpeg';
import s3 from '../assests/8.jpeg';
import s4 from '../assests/11.jpeg';
import { Lightbox } from '../components/Lightbox';
import { ArrowUpRight } from '../components/Icons';
import { allPhotos, featuredPhotos } from '../data/projects';

const TOTAL = allPhotos.length;
const gallery = allPhotos.map((p) => p.src);
const galleryAlts = allPhotos.map((p) => p.alt);

const steps = [
  { img: s1, title: 'Free on-site quote', text: 'Our appraiser walks the space with you and leaves a clear written quote. No pressure, no surprises.' },
  { img: s2, title: 'Prep & protect', text: 'We cover floors and furniture, repair and sand surfaces, and prime where needed so the finish lasts.' },
  { img: s3, title: 'Precision painting', text: 'Premium products, clean lines and even coats, on the schedule we agreed to.' },
  { img: s4, title: 'Walkthrough & guarantee', text: 'We inspect every surface with you, clean up completely and back the work for 3 years.' },
];

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Work() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="work" className="section section--grey work">
      <div className="container">
        <div className="head head--center">
          <span className="eyebrow reveal">Our work</span>
          <h2 className="reveal" style={d(80)}>
            Proof in Every Coat.
          </h2>
          <p className="lede reveal" style={d(160)}>
            Real projects around Delta, Ladner, Tsawwassen, Surrey and Vancouver.
          </p>
        </div>

        <div className="work__grid">
          {featuredPhotos.map((p, i) => (
            <button key={p.src} className="work__item reveal" style={d(i * 70)} onClick={() => setOpen(i)} aria-label={`View photo: ${p.alt}`}>
              <img src={p.thumb} alt={p.alt} loading="lazy" width={760} height={760} />
              <span className="work__open">
                <ArrowUpRight />
              </span>
            </button>
          ))}
        </div>

        <div className="work__more reveal">
          <button className="btn btn--ghost" onClick={() => setOpen(0)}>
            View all {TOTAL} photos
          </button>
        </div>

        <div className="process">
          <div className="head head--center">
            <span className="eyebrow reveal">How it works</span>
            <h2 className="reveal" style={d(80)}>
              Four Steps. Zero Surprises.
            </h2>
          </div>
          <ol className="process__list">
            {steps.map((s, i) => (
              <li key={s.title} className="step reveal" style={d(i * 90)}>
                <span className="step__num">{String(i + 1).padStart(2, '0')}</span>
                <img src={s.img} alt="" loading="lazy" />
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
      {open !== null && <Lightbox images={gallery} alts={galleryAlts} initialIndex={open} onClose={() => setOpen(null)} />}
    </section>
  );
}
